import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export const OPEN_SEARCH_EVENT = "sunsure:open-search";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "");
const modKey = isMac ? "⌘" : "Ctrl";

const SHORTCUTS = [
  { keys: `${modKey} + K`, description: "Open global search" },
  { keys: "?", description: "Show this list of shortcuts" },
  { keys: "J / K  or  ↓ / ↑", description: "Next / previous record while details are open" },
  { keys: `${modKey} + Enter`, description: "Save a contact note or comment" },
  { keys: "Esc", description: "Close the open dialog" },
];

function isTypingTarget(target) {
  if (!target) return false;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target.isContentEditable;
}

export default function KeyboardShortcuts() {
  const [helpOpen, setHelpOpen] = React.useState(false);

  React.useEffect(() => {
    const onKeyDown = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        window.dispatchEvent(new Event(OPEN_SEARCH_EVENT));
        return;
      }

      if (event.key === "?" && !isTypingTarget(event.target) && !event.metaKey && !event.ctrlKey) {
        event.preventDefault();
        setHelpOpen(true);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <Dialog open={helpOpen} onClose={() => setHelpOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Keyboard shortcuts</DialogTitle>
      <DialogContent>
        {SHORTCUTS.map(({ keys, description }) => (
          <Box
            key={keys}
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 0.75 }}
          >
            <Typography sx={{ fontSize: "14px" }}>{description}</Typography>
            <Box
              component="kbd"
              sx={{
                fontFamily: "inherit",
                fontSize: "12px",
                fontWeight: 600,
                px: 1,
                py: 0.25,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "6px",
              }}
            >
              {keys}
            </Box>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => setHelpOpen(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
